import { sortByMasteryPriority } from "@features/session-config/helpers/session-filters";
import type { Distribution } from "@memorang/types";

/**
 * Launch payloads carry the authoritative cell inventory, but a recommendation is
 * bounded by its requested duration. Session creation derives the item count by
 * summing the distribution, so the bound has to be applied to the buckets
 * themselves — draining weakest mastery first — rather than passed alongside them.
 */
export const capLaunchDistribution = (
	available: Distribution,
	numItems: number,
): Distribution => {
	const capped: Distribution = {};
	for (const key of Object.keys(available)) {
		capped[key] = 0;
	}

	let remaining = Math.max(0, numItems);
	for (const key of sortByMasteryPriority(Object.keys(available))) {
		if (remaining <= 0) {
			break;
		}
		const fromBucket = Math.min(remaining, available[key] ?? 0);
		capped[key] = fromBucket;
		remaining -= fromBucket;
	}

	return capped;
};
